import { create, v } from '@dojo/framework/core/vdom';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import { formatAriaProperties } from '@dojo/widgets/common/util';
import css from '../css/carousel.m.css';
const icache = createICacheMiddleware();
const factory = create({
    icache,
    theme
}).properties();
export const CardsLayout = factory(({ id, properties, children, middleware: { icache, theme } }) => {
    const themeCss = theme.classes(css);
    const { width = 996, xqa, aria = { live: 'polite' }, seatsVisible = 4, title, footnote, legend, useSmallHeader = false, headingLevel = 2 } = properties();
    const widgetId = `carousel-${id}`;
    const recalculate = () => {
        const w = window.innerWidth;
        const newVisible = w < 996 && w > 768 ? 3 : w < 768 && w > 540 ? 2 : w < 540 ? 1 : seatsVisible;
        icache.set('seatsVisible', newVisible);
    };
    recalculate();
    window.addEventListener('resize', recalculate);
    const visibleSeats = icache.getOrSet('seatsVisible', seatsVisible);
    const kids = children();
    const items = kids.map((kid, index) => v('div', {
        key: `seat-${index}`,
        role: 'listitem',
        classes: [themeCss.gridseat]
    }, [kid]));
    return v('div', {
        key: widgetId,
        id,
        widgetId,
        xqa,
        ...formatAriaProperties(aria),
        classes: [themeCss.root]
    }, [
        title || legend
            ? v('div', { classes: [useSmallHeader ? themeCss.headerSmall : themeCss.header] }, [
                title ? v(`h${headingLevel}`, { classes: [themeCss.title] }, [title]) : null,
                legend ? v('div', { classes: [themeCss.legend], innerHTML: legend }) : null
            ])
            : null,
        v('div', { classes: [themeCss.gridWrapper] }, [
            v('div', {
                key: 'seats',
                role: 'list',
                classes: [themeCss.grid],
                style: `grid-template-columns: repeat(${visibleSeats}, 1fr)`
            }, items)
        ]),
        footnote ? v('div', { classes: [themeCss.note] }, [footnote]) : null
    ]);
});
export default CardsLayout;
